import React, { useEffect, useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import axios from 'axios';
import Header from '../components/header';
import Sidebar from '../components/sidebar';
import Footer from '../components/footer';

function App() {

	const location = useLocation();
	const userID = sessionStorage.getItem("TRCUserId");
	const userEmail = sessionStorage.getItem("TRCUserEmail");
	const userName = sessionStorage.getItem("TRCUserName");
	const userPosition = sessionStorage.getItem("TRCUserPosition");
	const userType = sessionStorage.getItem("TRCUserType");
	const [employeeId, setEmployeeId] = useState(null);
	const apiKey = 'erpTrucoo';
    const [employeeData, setEmployeeData] = useState('');

	const getQueryParam = (param) => {
		const urlParams = new URLSearchParams(location.search);
		return urlParams.get(param);
	};
	
	useEffect(() => {
		const employee = getQueryParam('id');
		setEmployeeId(employee);
	}, [employeeId]);

    const getEmployee = async () => {
		try {
			const response = await axios.post('https://api.trucoo.in/employees/reports/', {empId: employeeId}, {
				headers: {
					'Content-Type': 'application/json',
					'X-API-KEY': 'erpTrucoo'
				}
			});
			console.log(response.data);
			if(response.data.status === 'success'){
				setEmployeeData(response.data.data);
			}
		} catch (error) {
			console.error("Error:", error.response || error.message);
		}
	};


	useEffect(() => {
		if(employeeId){
			getEmployee();
		}
		
	},[employeeId]);

	console.log(employeeId);

return(
<>
    <Header />
    <Sidebar />

    <div class="content-wrapper">
		<div class="container-full">
		
			<section class="content">
			<div class="box">
				<div class="box-header with-border">
				  <h4 class="box-title">Employee Data</h4>
				  <p class="mb-0 box-subtitle">All Employee Data</p>
				</div>
				<div class="box-body">
					<div class="table-responsive">
					  <table id="example" class="table text-fade table-bordered table-hover display nowrap margin-top-10 w-p100">
						<thead>
							<tr class="text-dark">
								<th>Date</th>
								<th>Company</th>
								<th>Action</th>
								<th>Next Update</th>
								<th>View</th>
								
							</tr>
						</thead>
						<tbody>
							{employeeData.length > 0 ? employeeData.map((employee, index) =>
							<tr key={index}>
								<td>{employee.date}</td>
								<td class="text-dark">{employee.clientData.companyName} - {employee.clientData.location}</td>
								<td>{employee.status}</td>
								<td>{employee.nextUpdate}</td>
								<td>
									<a href={`/clients-report?id=${employee.clientData.id}`} class="form-control" style={{textAlign: 'center'}}>View</a>
								</td>
								
							</tr>
							):(
								<tr>
									<td colSpan={6}>No Employee Data</td>
								</tr>
							)}
							
						</tbody>	
					</table>
					</div>              
				</div>
			  </div>
			</section>
		</div>
	</div>

	<Footer />
</>
);
}

export default App;